import { updateListingData } from '../utilities';

export default function processOwnerResults() {
    return async (ctx) => {
        if (ctx.data.resultIsLoading) return;
        const updatedListingsData = await updateListingData(ctx.data.listings, ctx.data.owner, ctx.data.brand);
        Object.assign(ctx.data, updatedListingsData);
    };
}
